import React from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import SubFooter from './SubFooter';

import '../scss/style.scss';
import SEO from './SEO';

class Layout extends React.Component {
  render() {
    const {
      bodyClass,
      children
    } = this.props;

    return (
      <>
        {/* SEO 由各页面自行调用，避免重复 meta 标签 */}
        <Helmet>
          <meta
            name="keywords"
            content="魔鬼鱼, 魔鬼鱼订货平台, 魔鬼鱼订货, B2B, 线上订货平台, 线上订货, 宠物订货平台, 宠物B2B订货, 宠物用品批发, 宠物门店进货, 宠物供应链, 一站式订货, 宠物行业平台"
          />
        </Helmet>
        <div className={`page${bodyClass ? ` ${bodyClass}` : ''}`}>
          <div id="wrapper" className="wrapper">
            <Header />
            <main>
              {children}
            </main>
          </div>
          <SubFooter />
        </div>
      </>
    );
  }
}

export default Layout;
